<template>
  <div>
    <nav-bar title="车辆保险管理"></nav-bar>
    <ih-panel
      v-for="(item, key) in panelList"
      @click.native="toRoute(item.text)"
      :sign="item.sign"
      :content="item.time"
      :text="item.text"
      :key="key"
    ></ih-panel>
    <div class="btn">
      <van-button
        type="primary"
        color="rgba(33,37,41,1)"
        block
        native-type="submit"
        @click="add()"
        >添加车辆保单
      </van-button>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import ihPanel from "@/components/ihPanel";
import { Button } from "vant";
export default {
  name: "vehicleinsurancelist",
  data() {
    return {
      panelList: [
        {
          url: require("@/assets/icon/icon_1.png"),
          text: "交强险保单",
          time: "2019/12/20 - 2020/12/20",
          sign: "1"
        },
        {
          url: require("@/assets/icon/icon_1.png"),
          text: "商业险保单",
          time: "2019/12/20 - 2020/12/203",
          sign: "1"
        },
        {
          url: require("@/assets/icon/icon_1.png"),
          text: "交强险保单",
          time: "2019/12/20 - 2020/12/20",
          sign: "1"
        },
        {
          url: require("@/assets/icon/icon_1.png"),
          text: "商业险保单",
          time: "2019/12/20 - 2020/12/20",
          sign: "1"
        },
        {
          url: require("@/assets/icon/icon_1.png"),
          text: "商业险保单",
          time: "2019/12/20 - 2020/12/20",
          sign: "1"
        },
        {
          url: require("@/assets/icon/icon_1.png"),
          text: "商业险保单",
          time: "2019/12/20 - 2020/12/20",
          sign: "1"
        },
        {
          url: require("@/assets/icon/icon_1.png"),
          text: "商业险保单",
          time: "2019/12/20 - 2020/12/20",
          sign: "1"
        },
        {
          url: require("@/assets/icon/icon_1.png"),
          text: "商业险保单",
          time: "2020/03/06 12:33",
          sign: "1"
        }
      ]
    };
  },
  components: {
    NavBar,
    ihPanel,
    "van-button": Button
  },
  methods: {
    add() {
      this.$router.push({ name: "vehicleinsurance" });
    }
  }
};
</script>

<style scoped>
.btn {
  width: 375px;
  height: 112px;
  background: rgba(255, 255, 255, 1);
  position: absolute;
  bottom: 0;
  padding: 15px 25px;
  box-sizing: border-box;
}
</style>
